"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyCodes = void 0;
// eslint-disable-next-line no-shadow
var KeyCodes;
(function (KeyCodes) {
    KeyCodes[KeyCodes["ESC"] = 27] = "ESC";
    KeyCodes[KeyCodes["ENTER"] = 13] = "ENTER";
    KeyCodes[KeyCodes["UP"] = 38] = "UP";
    KeyCodes[KeyCodes["DOWN"] = 40] = "DOWN";
    KeyCodes[KeyCodes["LEFT"] = 37] = "LEFT";
    KeyCodes[KeyCodes["RIGHT"] = 39] = "RIGHT";
    KeyCodes[KeyCodes["TAB"] = 9] = "TAB";
    KeyCodes[KeyCodes["SHIFT"] = 16] = "SHIFT";
    KeyCodes[KeyCodes["BACKSPACE"] = 8] = "BACKSPACE";
    KeyCodes[KeyCodes["C"] = 67] = "C";
    KeyCodes[KeyCodes["V"] = 86] = "V";
    KeyCodes[KeyCodes["Z"] = 90] = "Z";
})(KeyCodes = exports.KeyCodes || (exports.KeyCodes = {}));
exports.default = KeyCodes;
